import React from 'react'
import { Editor } from '@tinymce/tinymce-react'

const TinyEditor = ({ apiKey, article, onEditorChange, init }) => {
  return (
    <Editor 
      apiKey={apiKey}
      initialValue={article.document}
      onEditorChange={onEditorChange}
      init={init}
    />
  )
}

export default TinyEditor
